/* global axios */
import ApiClient from '../ApiClient';

class DealStatusAPI extends ApiClient {
  constructor() {
    super('pipeline/cards', { accountScoped: true });
  }

  // `productId`/`quantity`/`unitValue` descrevem O QUE foi vendido (Fase 59/F3).
  // Sem eles a venda entra no razão sem produto vinculado e não pode ser medida
  // por produto na tela de Oportunidades.
  markAsWon(
    itemId,
    {
      wonValue,
      wonNote,
      winningOfferIndex,
      productId,
      quantity,
      unitValue,
    } = {}
  ) {
    const payload = {};
    if (wonValue !== undefined && wonValue !== null && wonValue !== '') {
      payload.won_value = wonValue;
    }
    if (wonNote !== undefined && wonNote !== null && wonNote !== '') {
      payload.won_note = wonNote;
    }
    if (winningOfferIndex !== undefined && winningOfferIndex !== null) {
      payload.winning_offer_index = winningOfferIndex;
    }
    if (productId !== undefined && productId !== null && productId !== '') {
      payload.pipeline_product_id = productId;
      // Quantidade e unitário só fazem sentido acompanhando o produto: soltos,
      // descreveriam um item que a venda não tem.
      if (quantity !== undefined && quantity !== null && quantity !== '') {
        payload.quantity = quantity;
      }
      if (unitValue !== undefined && unitValue !== null && unitValue !== '') {
        payload.unit_value = unitValue;
      }
    }
    return axios.post(`${this.url}/${itemId}/deal_status/mark_won`, payload);
  }

  markAsLost(itemId, reason) {
    return axios.post(`${this.url}/${itemId}/deal_status/mark_lost`, {
      reason,
    });
  }

  reopen(itemId) {
    return axios.post(`${this.url}/${itemId}/deal_status/reopen`);
  }

  getLostReasonsAnalytics({ startDate, endDate } = {}) {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    return axios.get(
      `${this.url.replace('/cards', '')}/deal_status/lost_reasons`,
      { params }
    );
  }

  getCommonReasons() {
    return axios.get(
      `${this.url.replace('/cards', '')}/deal_status/common_reasons`
    );
  }
}

export default new DealStatusAPI();
